import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import useUpdateSpaceMember from '../../api/useUpdateSpaceMember';
import type { SpaceMemberWithProfile } from '../../types';

const formSchema = z.object({
  firstName: z.string().min(1, 'Ce champ est obligatoire'),
  lastName: z.string().min(1, 'Ce champ est obligatoire'),
  role: z.enum(['admin', 'board_member', 'reader']),
});

type FormValues = z.input<typeof formSchema>;
type FormValuesOutput = z.infer<typeof formSchema>;

type Props = {
  spaceId: string;
  member: SpaceMemberWithProfile;
  onClose: () => void;
};

export default function useEditMemberModal(props: Props) {
  const updateMember = useUpdateSpaceMember();
  const [serverError, setServerError] = useState<string | null>(null);

  const form = useForm<FormValues, unknown, FormValuesOutput>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      firstName: props.member.profiles?.first_name ?? '',
      lastName: props.member.profiles?.last_name ?? '',
      role: props.member.role,
    },
  });

  async function handleSubmit(data: FormValuesOutput) {
    setServerError(null);

    try {
      await updateMember.mutateAsync({
        memberId: props.member.id,
        userId: props.member.user_id,
        firstName: data.firstName,
        lastName: data.lastName,
        role: data.role,
        spaceId: props.spaceId,
      });
      props.onClose();
    } catch (err) {
      setServerError(err instanceof Error ? err.message : 'Une erreur est survenue');
    }
  }

  return {
    form,
    onSubmit: form.handleSubmit(handleSubmit),
    isSubmitting: updateMember.isPending,
    serverError,
  };
}
